const validateField = field => {
  if (!field) {
    return { valid: false, error: "Tieto vaaditaan." };
  }
  return { valid: true, error: null };
};

const validateDate = date => {
  const regex = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/g;
  if (!date) {
    return { valid: false, error: "Tieto vaaditaan." };
  } else if (date.match(regex)) {
    return { valid: false, error: "Päivämäärä tulee olla muotoa pp.kk.vvvv" };
  }
  return { valid: true, error: null };
};

const validateEmail = email => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email) {
    return { valid: false, error: "Kenttä on pakollinen." };
  }
  if (!email.match(regex)) {
    return { valid: false, error: "Kenttä on väärässä muodossa." };
  }
  return { valid: true, error: null };
};

export { validateField, validateDate, validateEmail };
